import { clone, isEqual } from "lodash";
import moment from "moment";

export function getLabel(attribute) {
  if (!attribute) {
    return;
  }

  const { id, label, name, readableText } = attribute;

  // Early returns in order of preference for label
  if (readableText) {
    return readableText;
  }

  if (label) {
    return label;
  }

  if (name) {
    return name;
  }

  if (id) {
    return id;
  }

  return attribute;
}

export function formValueShouldBeNull(value) {
  if (!hasValue(value)) {
    return true;
  }

  if (isEmptyArrayOrObject(value)) {
    return true;
  }
  if (typeof value === "string" && value.trim() === "") {
    return true;
  }
  return false;
}

export function hasValue(value) {
  if (value === undefined || value === null) {
    return false;
  }

  return true;
}

export function isEmptyArrayOrObject(value) {
  if (typeof value === "object" && !Object.keys(value).length) {
    return true;
  }
}

export function normalizeValue(value) {
  // Turn arrays into comma-separated strings
  if (Array.isArray(value)) {
    value = value.join(", ");
  }

  if (typeof value !== "string") {
    return value;
  }

  return value.trim().toLowerCase();
}

export function operatorDoesNotEqual(value, searchTerm) {
  return !operatorEquals(value, searchTerm);
}

export function operatorDoesNotInclude(value, searchTerm) {
  return !operatorIncludes(value, searchTerm);
}

export function operatorEquals(value, searchTerm) {
  // If arrays they need to be sorted before being compared
  if (Array.isArray(value)) {
    value = clone(value).sort();
  }

  if (Array.isArray(searchTerm)) {
    searchTerm = clone(searchTerm).sort();
  }

  if (typeof value === "string") {
    value = normalizeValue(value);
  }

  if (typeof searchTerm === "string") {
    searchTerm = normalizeValue(searchTerm);
  }

  if (value === undefined) {
    value = null;
  }

  // Lodash isEqual will work on arrays and objects
  // Ref: https://lodash.com/docs/4.17.15#isEqual
  return isEqual(value, searchTerm);
}

export function operatorIncludes(value, searchTerm) {
  if (typeof value !== "string" && !Array.isArray(value)) {
    return false;
  }

  if (typeof value === "string") {
    value = normalizeValue(value);
    searchTerm = normalizeValue(searchTerm);
    return value.includes(searchTerm);
  }

  if (Array.isArray(searchTerm)) {
    return searchTerm.every(term => value.includes(term));
  }

  return value.includes(searchTerm);
}

export function sortAlphabetically(string1, string2) {
  if (typeof string1 !== "string") {
    throw new Error(`Cannot alphabetically sort ${string1}`);
  }

  if (typeof string2 !== "string") {
    throw new Error(`Cannot alphabetically sort ${string2}`);
  }

  return string1.toLowerCase() < string2.toLowerCase() ? -1 : 1;
}

export function sortAlphabeticallyByLabel(
  { label: label1 },
  { label: label2 }
) {
  return sortAlphabetically(label1, label2);
}

export function validateHasValue(value) {
  return hasValue(value) || "Input requires a value";
}

export function formatTimestamp(timestamp, format = "MMM Do YYYY, h:mm A") {
  return `${moment.utc(timestamp).local().format(format)}`;
}
